export function RollMeter({ rollCount }: { readonly rollCount: number }) {
  return (
    <div
      aria-label={`roll count ${rollCount} of 3`}
      className="yacht-roll-meter"
      data-testid="yacht-roll-meter"
      role="img"
    >
      {[0, 1, 2].map((index) => (
        <span
          className="yacht-roll-dot"
          data-filled={index < rollCount ? "true" : "false"}
          key={index}
        />
      ))}
    </div>
  );
}
